<template>
  <header class="default header">
    <div class="center-content">
      <a class="logo" id="logo" href="https://www.essilorusa.com" title="Go to EssilorUSA.com. See More. Do More." aria-label="EssilorUSA.com">
          <img class="img-logo" src="/images/essilor-logo-v2.png" alt="Essilor_RGB_Blue">
      </a>
      <div class="row_2 no-gutters">
        <label class="logo-title" for="">Essilor Employee <strong class="logo-sub-title">New Product Learning & Experience</strong></label>
        <a class="logo-mobile" href="https://www.essilorusa.com" aria-label="EssilorUSA.com">
          <img src="/images/essilor-logo-v2.png" alt="essilor-logo-v2">
        </a>
        <div class="row_2 no-gutters no-padding" id="mobile-navs-wrapper" v-if="!$route.path.includes('login')">
          <button v-if="!expanded" class="transparent-btn" @click="expanded = true" style="margin: auto">
            <img style="margin: 15px" src="/images/hamburger.svg" alt="Hamburger">
          </button>
          <button v-if="expanded" class="transparent-btn" @click="expanded = false" style="margin: auto">
            <img style="margin: 15px" src="/images/close.svg" alt="Close">
          </button>
        </div>
        <div class="row_2 no-gutters no-padding" id="desktop-navs-wrapper">
          <!-- <div id="aux-nav-wrapper"></div> -->
          <div id="main-nav-wrapper">

            <nav class="main-nav">
              <ul>
                <li v-if="!(pathname.includes('login') || pathname === '/')">
                  <p>
                    <router-link to="/">HOME</router-link>
                  </p>
                </li>
                <li v-if="!pathname.includes('login')">
                  <button class="transparent-btn account-btn" @click="menuExpanded = !menuExpanded">
                    <img src="/images/account_circle.svg" alt="Account Circle">
                  </button>
                  <div class="logout-menu" v-if="menuExpanded" @mouseleave="closeMenuAccount()" @mouseenter="clearMenuTimeout()">
                    <button class="transparent-btn menu-btn" @click="logout()">LOGOUT</button>
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="top-subnav">
      </div>
      <div id="myTopnav" class="topnav" :class="{'responsive': expanded}">
        <div class="menu-content">
          <ul>
            <li v-if="!(pathname.includes('login') || pathname === '/')">
              <router-link to="/">HOME</router-link>
            </li>
          </ul>
          <ul>
            <li>
              <button class="nav-btn" @click="logout()">LOGOUT</button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>
<script>

import auth from "@/api/auth.js";

export default {
  computed: {
    pathname() {
      return this.$route ? this.$route.path : window.location.pathname
    }
  },
  methods: {
    toggleMenu() {
      this.expanded = !this.expanded;
    },
    closeMenuAccount() {
      this.timer = setTimeout(() => {
        this.menuExpanded = false
      }, 1000);
    },
    clearMenuTimeout() {
      clearTimeout(this.timer)
    },
    logout() {
      auth.logout()
      localStorage.removeItem('vuex')
      localStorage.removeItem('programKey')
      //this.$router.replace('/login')
    }
  },
  data() {
    return {
      expanded: false,
      menuExpanded: false,
      timer: null
    };
  },
  created() {
  }
};

</script>
<style>
@import url(https://fonts.googleapis.com/css?family=Noto+Sans:400,600,700);
.logo-title {
    display: flex;
    position: absolute;
    margin-top: 2px;
    margin-left: 110px;
    margin-right: 50px;
    z-index: 9;
    font-family: 'Noto Sans', sans-serif;
    color: #fff;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 2px;
    gap: 10px;
}

.img-logo {
    width: 60px;
    margin-left: 20px;
    border: 1px solid #000000;
}

.transparent-btn {
  background: transparent;
  padding: 0;
  box-shadow: unset;
  margin: -5px 0;
}

.logout-menu {
  height: 65px;
  background: white;
  border-radius: 5px;
  position: absolute;
  right: 0px;
  top: 52px;
  padding: 15px 0px;
  box-shadow: 0px 2px 7px 0px rgb(0 0 0 / 42%);
}

.menu-btn {
  padding: 10px 20px;
  font-size: 14px;
}
.menu-btn:hover {
  background: #eaeaea;
}

.account-btn {
  height: 30px;
  width: 30px;
}
.account-btn:hover {
  background-color: #0000e0;
  border-radius: 5px;
}
.main-nav-wrapper {
  background-color: black;
}

.nav-btn {
  color: white;
  text-align: center;
  width: 100%;
}

@media screen and (max-width: 1200px) {
  .logo-title {
    font-size: 1.5rem;
    margin-top: 10px;
  }
}

@media screen and (max-width: 960px) {
  .logo-title {
    margin-top: 16px;
    margin-left: 100px;
    font-size: 1rem;
  }
  .logo-mobile img {
    width: 60px;
  }
}

@media screen and (max-width: 680px) {
  .logo-title {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    margin-top: 4px;
    gap: 0;
  }
  .logo-sub-title {
    font-size: 10px;
  }
}

@media screen and (max-width: 450px) {
  .logo-title {
    display: flex;
    flex-wrap: wrap;
    margin-top: 4px;
    gap: 0;
  }
  .logo-sub-title {
    font-size: 8px;
  }
}


</style>